/* eslint-disable global-require */

import angular from 'angular';
import { UsersService } from '../../../shared/users/users.service';
import { User } from '../../../src/app/@shared-types/user';

import './profile-image.style.scss';

export const UserProfileImageComponent = {
  selector: 'profileImage',
  restrict: 'E',
  bindings: {
    userId: '@',
  },
  template: /* html */ `
    <div class="profile-image">
      <div class="img-wrap" ng-show="$ctrl.showLogo">
        <img src="img/favicon.png">
      </div>

      <div ng-show="!$ctrl.invalid && !showLogo">
        <div ng-if="!$ctrl.showPlaceholder" class="img-wrap">
          <static-resource static-id="$ctrl.staticId"></static-resource>
        </div>

        <div ng-if="$ctrl.showPlaceholder && !showLogo" class="placeholder">
          <i class="fa-duotone fa-circle-user"></i>
        </div>
      </div>

      <div class="hover-content">
        <span>{{$ctrl.user.first_name}} {{$ctrl.user.last_name}}</span>
      </div>
    </div>
  `,
  controller: class ProfileImageController {
    private usersService: UsersService;

    private userId!: string;

    private user: User | null = null;

    private invalid = false;

    private showPlaceholder = false;

    private staticId = '';

    private showLogo = false;

    private loading = true;

    constructor(
      usersService: UsersService,
    ) {
      'ngInject';

      this.usersService = usersService;
    }

    $onInit(): void {
      this.init();
    }

    private init = () => {
      if (!this.userId) {
        this.loading = false;
        this.invalid = true;
      }

      /** Super Admin */
      if (parseInt(this.userId, 10) === -420000) {
        this.showLogo = true;
        return;
      }

      if (!this.invalid && this.userId) {
        const user = this.usersService.getUserFromId(parseInt(String(this.userId), 10));
        if (!user) return;

        this.showPlaceholder = user.profile_image === '';
        this.staticId = user.profile_image;
        this.user = user;
        this.loading = false;
      }
    };
  },
};

export default angular.module('autoboard.profileImage', [])
  .component(UserProfileImageComponent.selector, UserProfileImageComponent)
  .name;
